//////////// CSS /////////////
import './styles.css';
import ic_nav_pre from './assets/icon/ic_chevron_left_white_48dp.png';
import ic_nav_next from './assets/icon/ic_chevron_right_white_48dp.png';
// import ic_search from './assets/icon/ic_search_black.png';
import ic_true from './assets/icon/true.png';
import ic_false from './assets/icon/false.png';

//////////// REACT /////////////
import React from "react";
import { useHistory } from "react-router-dom";
// import QRCode from "react-qr-code";

//////////// REDUX | STORE | SERVICE /////////////
// import { useDispatch } from 'react-redux';
// import { showLoad, dismissLoad } from '../../store/slice/loading';

//////////// COMPONENT /////////////
import Modal from './component/action-modal-form';
import ModalAction from './component/action-modal-form-action';
import ModalViewImage from './component/modal-view-image'

function InsaneTableNoHttp(props) {
    // locationStack
    // console.log(props);

    const history = useHistory();

    const tableOption = props.option;
    const headTable = tableOption.mapTable;
    const limitRow = props.limitRow;
    const dataTable = props.dataTable;
    const pageTotal = Math.ceil(dataTable.length / limitRow);

    const [dataTableSplit, setDataTableSplit] = React.useState([]);
    const [dataTableMissRow, setDataTableSplitMissRow] = React.useState(0);

    const [page, setPage] = React.useState(1);

    React.useEffect(() => {
        // console.log("on props change:", props);
        const controller = new AbortController();

        onActiveDataTable();

        return () => { controller.abort() };
    }, [props, page]);// eslint-disable-line react-hooks/exhaustive-deps

    function onActiveDataTable() {
        setDataTableSplit([]);
        setDataTableSplitMissRow(0);

        let start_index = ((page * limitRow) - limitRow);
        let stop_index = (start_index + limitRow);

        let new_dataTable = dataTable.filter((_, index) => ((index >= start_index) && (index < stop_index)));

        if (new_dataTable.length < limitRow) {
            let countMissRow = limitRow - new_dataTable.length;
            setDataTableSplitMissRow(countMissRow);
        }
        setDataTableSplit(new_dataTable);
    }

    function twoDigit(n) {
        let number = parseInt(n);
        if (number <= 9) {
            return "0" + number
        } else {
            return "" + number
        }
    }

    function ConvertDate(dateString, type = "datetime") {
        // console.log(dateString);
        if (dateString) {
            let date = new Date(dateString);
            if (type === "datetime") {
                return twoDigit(date.getDate()) + "/" + twoDigit((date.getMonth() + 1)) + "/" + twoDigit(date.getFullYear()) + ` -- ` + twoDigit(date.getHours()) + ":" + twoDigit(date.getMinutes()) + ":" + twoDigit(date.getSeconds())
            }
            if (type === "date") {
                return twoDigit(date.getDate()) + "/" + twoDigit((date.getMonth() + 1)) + "/" + twoDigit(date.getFullYear())
            }
            if (type === "time") {
                return twoDigit(date.getHours()) + ":" + twoDigit(date.getMinutes()) + ":" + twoDigit(date.getSeconds())
            }
        } else {
            return "";
        }
    }

    function onNext() {
        let _page = page + 1;
        if (_page <= pageTotal) {
            setPage(_page);
        }
    }

    function onPre() {
        let _page = page - 1;
        if (_page > 0) {
            setPage(_page);
        }
    }

    // function onChangeLimitRow(rowNumber) {

    //     setLimitRow(parseInt(rowNumber));

    //     let _option = tableOption;
    //     _option.api.view.dataReq.index = 0;
    //     _option.api.view.dataReq.count = parseInt(rowNumber);

    //     setTableOption(_option);
    //     setPage(1);

    // }

    function onPageNavigate(url, data) {
        let option_navigate = { pathname: url }
        option_navigate.state = data;
        history.push(option_navigate);
    }

    // function setValueQRcode(sampleValue, mapValue, value) {
    //     // console.log("sampleValue ----->", sampleValue);
    //     // console.log("mapValue ----->", mapValue);
    //     // console.log("value ----->", value);
    //     let result = sampleValue;
    //     if (mapValue.length > 0) {
    //         for (let i = 0; i < mapValue.length; i++) {
    //             const map = mapValue[i];
    //             result[map.attName] = value[map.attMap];
    //         }
    //     }
    //     // console.log(result);
    //     return JSON.stringify(result);
    // }

    function getValueById(attCompare, arrForFilter, valueFilter) {
        // console.log(attCompare, arrForFilter, valueFilter);
        let _find = arrForFilter.filter((e) => {
            return e[attCompare] === valueFilter;
        })
        if (_find.length > 0) {
            return _find[0].displayName
        } else {
            return ""
        }
    }

    return (
        // (stateTable) ? (
        <div className={"insane-table " + props.className}>
            <div className="box-table" style={{ overflow: 'unset' }}>
                <table>
                    <thead>
                        <tr>
                            {/* <th>No</th> */}
                            {
                                headTable.map((header, header_index) => (
                                    <th key={header_index}>{header.displayName}</th>
                                ))
                            }
                            {
                                (tableOption.action.length > 0) ? (<th>ACTION</th>) : (null)
                            }
                        </tr>
                    </thead>
                    <tbody>
                        {
                            dataTableSplit.map((row, i) => (
                                <tr key={i} style={{ height: 55 }}>
                                    {/* <td>{i + 1}</td> */}
                                    {
                                            headTable.map((col, j) => {
                                                if (col.type === "id") {
                                                    if (col.form.element === "select") {
                                                        return <td key={j}>{getValueById("value", col.form.option, row[col.attName])}</td>
                                                    } else {
                                                        return <td key={j}>{row[col.attName]}</td>
                                                    }
                                                } else if (col.type === "text") {
                                                    return <td key={j}>{row[col.attName]}</td>
                                                } else if (col.type === "bt-view-image") {
                                                    if (row[col.attName]) {
                                                        return <td key={j}><ModalViewImage data={row} titleButton="View"></ModalViewImage></td>
                                                    } else {
                                                        return <td key={j} style={{ color: "#CCCCCC" }}>No Image</td>
                                                    }
                                                } else if (col.type === "date" || col.type === "datetime" || col.type === "time") {
                                                    return <td key={j}>{ConvertDate(row[col.attName], col.type)}</td>
                                                } else if (col.type === "approve") {
                                                    if (row[col.attName]) {
                                                        return <td key={j} style={{ color: "#1FD606" }}>Approved</td>
                                                    } else {
                                                        return <td key={j} style={{ color: "#CCCCCC" }}>Not Approved</td>
                                                    }
                                                } else if (col.type === "boolean") {
                                                    if (row[col.attName]) {
                                                        return <td key={j} ><img src={ic_true} alt="ic_true" /></td>
                                                    } else {
                                                        return <td key={j} ><img src={ic_false} alt="ic_false" /></td>
                                                    }
                                                } else if (col.type === "cover") {
                                                    if (row[col.attName]) {
                                                        return <td key={j} style={{ color: "#1FD606" }}>Cover</td>
                                                    } else {
                                                        return <td key={j} style={{ color: "#CCCCCC" }}>-</td>
                                                    }
                                                } else if (col.type === "status") {
                                                    if (row[col.attName]) {
                                                        if (row[col.attName] === "NORMAL") {
                                                            return <td key={j} style={{ color: "#1fd606", fontWeight: "bolder" }}>{row[col.attName]}</td>
                                                        }else{
                                                            return <td key={j} style={{ color: "red", fontWeight: "bolder" }}>{row[col.attName]}</td>
                                                        }
                                                    } else {
                                                        return <td key={j} style={{ color: "#CCCCCC" }}>-</td>
                                                    }
                                                } else if (col.type === "text-color") {
                                                    if (row[col.attName]) {
                                                        if (row[col.attName] > 0) {
                                                            return <td key={j} style={{ color: col.color, fontWeight: "bolder" }}>{row[col.attName]}</td>
                                                        }else{
                                                            return <td key={j}>{row[col.attName]}</td>
                                                        }
                                                    } else {
                                                        return <td key={j} style={{ color: "#CCCCCC" }}>0</td>
                                                    }
                                                } else {
                                                    return (null)
                                                }
                                            })
                                        }
                                    {
                                        (tableOption.action.length > 0) ? (
                                            <td>
                                                <div style={{ display: "flex" }}>
                                                    {
                                                        tableOption.action.map((action, action_index) => {

                                                            if (action.mode === "page") {
                                                                return (
                                                                    ( action.option.enable_by && row[action.option.enable_by]) ?
                                                                        (
                                                                            <button key={action_index} className="custom-input bt_active bt_search"
                                                                            onClick={() => onPageNavigate(action.option.url, row)}>{action.name}</button>
                                                                        ) : (null)
                                                                    );
                                                            } else if (action.mode === "modal-form") {
                                                                return <Modal key={action_index} type={action.option.type}
                                                                    api={tableOption.api} data={row} titleButton={action.name} mapTable={headTable}></Modal>;
                                                            } else if (action.mode === "modal-form-action") {
                                                                return <ModalAction key={action_index} type={action.option.type} reload={() => props.reload()}
                                                                    api={tableOption.api} data={row} titleButton={action.name} mapTable={headTable}></ModalAction>;
                                                            } else {
                                                                return (null);
                                                            }

                                                        })
                                                    }
                                                </div>
                                            </td>
                                        ) : (null)
                                    }
                                </tr>
                            ))
                        }
                        {/* {
                            Array.from(Array(dataTableMissRow).keys()).map((row, i) => (
                                <tr key={i} style={{ height: 55 }}>
                                    {headTable.map((col, j) => <td key={j}></td>)}
                                    {(tableOption.action.length > 0) ? (<td></td>) : (null)}
                                </tr>
                            ))
                        } */}
                    </tbody>
                </table>
                <div className="tool">
                    {/* {
                            (tableOption.qr) ? (
                                <div style={{ fontSize: 18, color: "red", fontWeight: "bolder" }}>
                                    ** Press [ Ctrl + p ] to Print QRCode {tableOption.tableName}.
                                    Recommend as Set Row table to 12, Before print.
                                </div>
                            ) : (null)
                        } */}
                    {
                        (dataTableSplit.length === 0) ? (<div style={{ fontSize: 18 }}>NO DATA RESULT</div>) : (null)
                    }
                    <div style={{ flexGrow: 1 }}></div>
                    {/* <div>Row</div>
                        <input type="number" style={{ marginRight: 20 }} value={limitRow}
                            onChange={(e) => {
                                if (e.target.value < 1) {
                                    onChangeLimitRow(1)
                                } else if (e.target.value > 20) {
                                    onChangeLimitRow(12)
                                } else {
                                    onChangeLimitRow(e.target.value)
                                }
                            }}></input> */}
                    <div>Page</div>
                    <button onClick={onPre}><img src={ic_nav_pre} alt="ic_pre" /></button>
                    <input type="number" value={page} onChange={(e) => {
                        if (e.target.value > pageTotal) {
                            setPage(parseInt(pageTotal))
                        } else if (e.target.value < 1) {
                            setPage(1)
                        } else {
                            setPage(parseInt(e.target.value))
                        }
                    }}></input>
                    <div> / {pageTotal}</div>
                    <button onClick={onNext}><img src={ic_nav_next} alt="ic_next" /></button>
                </div>
            </div >
            {/* <div id="print-content" >
                    {
                        (tableOption.qr) ? (
                            <div style={{ display: "flex", flexDirection: "row", flexWrap: "wrap", alignItems: "center", justifyContent: "center" }}>
                                {
                                    dataTable.map((row, i) => (
                                        <div className="box-qr" key={i}
                                            style={{ width: 200, height: 230, display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column", border: "1px #555 dashed", padding: 15 }}>
                                            <div className="qr-style" ></div>
                                            <p style={{ textAlign: "center", fontSize: "12px", color: "#444", fontWeight: "bold", margin: 0 }}></p>

                                            <QRCode
                                                bgColor={tableOption.qr.option.bgColor}
                                                fgColor={tableOption.qr.option.fgColor}
                                                level={tableOption.qr.option.level}
                                                size={120}
                                                title={tableOption.qr.option.title}
                                                value={setValueQRcode(tableOption.qr.sampleValue, tableOption.qr.mapValue, row)} />

                                            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", margin: "10px 0", fontSize: "12px" }}>
                                                {tableOption.tableName === "Equipment" ?
                                                    <p style={{ textAlign: "center", color: "black", margin: 0, fontSize: 12, fontWeight: "bolder" }}>{row.tagid}</p>
                                                    :
                                                    <p style={{ textAlign: "center", color: "black", margin: 0, fontSize: 10, fontWeight: "bolder" }}>{row.equipmentgroupname}</p>
                                                }
                                                <p style={{ textAlign: "center", margin: 0, fontSize: 10, fontWeight: "bolder", color: "#5d58e0" }}>{tableOption.tableName}</p>
                                            </div>
                                        </div>
                                    ))
                                }
                            </div>
                        ) : (null)
                    }
                </div> */}

        </div>
        // ) : (<div style={{ display: "flex", alignItems: "center", justifyContent: "center", marginBottom: 10 }}></div>)
    );
}

export default InsaneTableNoHttp;